import baseTool from '../../utils/baseFunction';
import flightApi from '../../request/flightApi';

const state = {
	cityData: [], // 储存城市列表，减少请求次数。
	gzCity: '广州', // 列1广州市定值
	gzCityPortCode: 'CAN', // 列1广州市三字码

	szCity: '深圳', // 列2深圳市定值
	szCityPortCode: 'SZX', // 列2深圳市三字码

	zhCity: '珠海', // 列3珠海市定值
	zhCityPortCode: 'ZUH', // 列3珠海市三字码    


	depDate: baseTool.dateFormat(new Date(), 'yyyy-MM-dd'), // 选择日期
	backDate: baseTool.dateFormat(new Date(), 'yyyy-MM-dd'), // 选择日期
	depCity: '广州', // 出发城市
	depCityPortCode: 'CAN', // 出发地机场三字码
	arrCity: '北京', // 到达城市，客户自选。
	arrCityPortCode: 'BJS', // 到达城市或机场三字码
	airCompanyCode: '', // 航空公司代码
	airCompanyName: '全部', // 航空公司名称
	flightType: 1, // 航程类型 1=单程，2=往返 默认1无须选择
	psgType: 1, // 乘客类型，1-成人 2-儿童 3-成人+儿童  默认1无须选择
	cabinRank: 0, // 仓位等级 0=不限 1=头等舱 2=公务舱 3=经济舱 默认3无须选择
	directFlight: 1, // 是否直飞 0=不限 1=是 2=其它  默认1无须选择
	isDep: true,// 是否为出发  默认true为出发，false为返程，根据出发与否api请求相关参数需对调。

	selectedFlightList: [],
	selectedPolicyList: [],
	
	depFlightList:[],
	backFlightList:[],

	ifBackRefresh:true,//是否后退不刷新，true刷新，false不刷新
}

const getters = {

}

const actions = {

}

const mutations = {
	setFlightQueryCondition(state, dataObj) {
		for (let prop in dataObj) {
			if (dataObj[prop] !== undefined) {
				state[prop] = dataObj[prop];
			}
		}
	},
	clearData(state) {
		state.depCity = '';
		state.depCityPortCode = '';
		state.arrCity = '北京'; // 到达城市，客户自选。
		state.arrCityPortCode = 'BJS'; // 到达城市或机场三字码
		state.airCompanyCode = ''; // 航空公司代码
		state.airCompanyName = '全部'; // 航空公司名称
		state.flightType = 1; // 航程类型 1=单程，2=往返 默认1无须选择
		state.psgType = 1; // 乘客类型，1-成人 2-儿童 3-成人+儿童  默认1无须选择
		state.cabinRank = 0; // 仓位等级 0=不限 1=头等舱 2=公务舱 3=经济舱 默认3无须选择
		state.directFlight = 1; // 是否直飞 0=不限 1=是 2=其它  默认1无须选择

		state.selectedFlightList = [];
		state.selectedPolicyList = [];
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/flight.js